

import Vue from 'vue'
import App from './App'
import router from './router'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css';
import HeyUi from 'heyui'
import i18n from './lang/lang'
import store from './store'
import Vant from 'vant';
Vue.use(HeyUi)
require("heyui/themes/index.css")
import axios from 'axios'
Vue.prototype.$ajax = axios;
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(ConfirmPlugin);
Vue.use(AlertPlugin);
Vue.use(Vant);


Vue.config.productionTip = false

Vue.prototype.$addCommas = (num,decimal) => {

if (!num && num !== 0) {
return ''
}
if(decimal){

num = Number(num).toFixed(decimal)

}
num += ''

return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* eslint-disable no-new */
new Vue({
el: '#app',
router,

store,
components: { App },
i18n,
template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js